import React from "react";

function Features() {
  return (
    <section className="features-one" id="aboutus">
      <div className="container">
        <div className="row">
          {[
            { img: "1sticon.png", value: "100+", label: "Properties Under Management" },
            { img: "2ndicon.png", value: "200+", label: "Total Residential Units" },
            { img: "3rdicon.png", value: "180K+", label: "Square Feet in Managed Assets" },
            { img: "4thicon.png", value: "150+", label: "Completed Development & Renovation Projects" },
          ].map((item, i) => (
            <div key={i} className="col-xl-6 col-lg-4 wow fadeInUp" data-wow-delay={`${i * 200}ms`} data-wow-duration="1500ms">
              <div className="features-one__single">
                <div className="features-one__single-icon">
                  <span><img src={`assets/images/suhani/${item.img}`} alt="" /></span>
                </div>
                <div className="features-one__single-text">
                  <h4><strong>{item.value}</strong> {item.label}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;